import { Locale } from 'modules/domains/template';
import { Nullish } from 'utils/tsHelpers';
import { DifferentSelectedDefaultLocaleThanProjectBanner } from './DifferentSelectedDefaultLocaleThanProjectBanner';
import { NoDefaultLocaleBanner } from './NoDefaultLocaleBanner';

type DefaultLocaleSelectFormFieldBannerProps = {
  selectedDefaultLocale: Nullish<Locale>;
  templateDefaultLocale: Nullish<Locale>;
  isTemplateDefaultLocaleModifiable: boolean;
  isTemplateDefaultDifferentThanProject: boolean;
  isSelectedDefaultLocaleDifferentThanProject: boolean;
};

export const DefaultLocaleSelectFormFieldBanner = ({
  templateDefaultLocale,
  selectedDefaultLocale,
  isTemplateDefaultLocaleModifiable,
  isTemplateDefaultDifferentThanProject,
  isSelectedDefaultLocaleDifferentThanProject,
}: DefaultLocaleSelectFormFieldBannerProps) => {
  if (!isTemplateDefaultLocaleModifiable && isTemplateDefaultDifferentThanProject) {
    return <NoDefaultLocaleBanner templateDefaultLocale={templateDefaultLocale} />;
  } else if (isSelectedDefaultLocaleDifferentThanProject) {
    return (
      <DifferentSelectedDefaultLocaleThanProjectBanner
        selectedDefaultLocale={selectedDefaultLocale}
      />
    );
  }
  return null;
};
